export class StorageUnitType {
  public static KB = 1;
  public static MB = 2;
  public static GB = 3;
  public static TB = 4;
  public static PB = 5;
}
